import SweetAlert from './SweetAlert';

export default SweetAlert;
